import type {
  AddressDTO,
  CarrierDTO, DeliveryDateDTO,
  DeliveryMethods as DeliveryMethodsDTO,
  DropoffMethodDTO,
  OpeningHoursDTO,
  ShipmentMethodDTO
} from '@cloudsuite/cs-ordering-defs'
import {
  Carrier,
  DeliveryMethod,
  DropoffMethod,
  OpeningHours,
  ShipmentMethods,
  DropoffAddress,
  DeliveryDate
} from './shipment-methods.js'

export function parseDTO<T, U>(Target: new (arg: T) => U, dto: T): U {
  return new Target(dto)
}

export const parseCarrier = (carrier: CarrierDTO): Carrier => parseDTO(Carrier, carrier)
export const parseDropoffAddress = (address: AddressDTO) => parseDTO(DropoffAddress, address)
export const parseOpeningHours = (hours: OpeningHoursDTO) => parseDTO(OpeningHours, hours)
export const parseDeliveryMethod = (method: ShipmentMethodDTO) => parseDTO(DeliveryMethod, method)
export const parseDropoffMethod = (method: DropoffMethodDTO) => parseDTO(DropoffMethod, method)
export const parseShipmentMethods = (methods: DeliveryMethodsDTO) => parseDTO(ShipmentMethods, methods)
export const parseDeliveryDate = (deliveryDate: DeliveryDateDTO) => parseDTO(DeliveryDate, deliveryDate)
